import { render, staticRenderFns } from "./WorkFiles.vue?vue&type=template&id=49103b95&scoped=true"
import script from "./WorkFiles.vue?vue&type=script&lang=js"
export * from "./WorkFiles.vue?vue&type=script&lang=js"
import style0 from "./WorkFiles.vue?vue&type=style&index=0&id=49103b95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49103b95",
  null
  
)

export default component.exports